import React, { useState } from 'react';
import api from '../../config/axios';
import { useNavigate } from 'react-router-dom';
import '../order/OrderCreate.css';

const GroupOrderJoin: React.FC = () => {
  const [sessionCode, setSessionCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleJoinSession = async () => {
    if (!sessionCode || sessionCode.length !== 3) {
      setError('Session code phải có 3 số');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const res = await api.post('/api/group-orders/join', {
        sessionCode
      });

      const { tableName } = res.data.data;
      
      setSuccess(`Đã tham gia session thành công! Bàn: ${tableName}`);
      
      setTimeout(() => {
        navigate(`/orders/group-order?sessionCode=${sessionCode}`);
      }, 1500);

    } catch (err: any) {
      setError(err.response?.data?.message || 'Lỗi khi tham gia session');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="order-create-bg">
      <div className="order-create-container">
        <h2 className="order-create-title">THAM GIA ĐẶT MÓN NHÓM</h2>
        
        <div style={{ 
          background: '#fff7e6', 
          border: '1px solid #ffd591', 
          borderRadius: 8, 
          padding: 16, 
          marginBottom: 24,
          fontSize: 14,
          color: '#d46b08'
        }}>
          <strong>🔑 Hướng dẫn:</strong>
          <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
            <li>Nhập session code 3 số từ người tạo nhóm</li>
            <li>Session code sẽ được hiển thị khi tạo nhóm</li>
            <li>Sau khi tham gia, bạn có thể đặt món cùng nhóm</li>
            <li>Tất cả sẽ thanh toán chung một hóa đơn</li>
          </ul>
        </div>

        {error && <div className="order-create-message order-create-error">{error}</div>}
        {success && <div className="order-create-message order-create-success">{success}</div>}
        
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold', color: '#333' }}>
            Session Code (3 số):
          </label>
          <input
            type="text"
            placeholder="Nhập session code (VD: 123)"
            value={sessionCode}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 3);
              setSessionCode(value);
            }}
            className="order-create-input"
            style={{ 
              fontSize: '18px', 
              textAlign: 'center', 
              letterSpacing: '8px',
              fontWeight: 'bold'
            }}
            maxLength={3}
          />
        </div>

        <button 
          onClick={handleJoinSession} 
          className="order-create-submit-btn" 
          disabled={loading || sessionCode.length !== 3}
          style={{ width: '100%', fontSize: '16px', padding: '16px' }}
        >
          {loading ? 'Đang tham gia...' : 'Tham Gia Nhóm'}
        </button>

        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <button 
            onClick={() => navigate(-1)}
            className="order-create-menu-add-btn"
            style={{ marginRight: 12 }}
          >
            Quay lại
          </button>
          <button 
            onClick={() => navigate('/orders/group-create')}
            className="order-create-menu-add-btn"
          >
            Tạo nhóm mới
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupOrderJoin; 